import(/* webpackMode: "eager" */ "/var/www/sahha/apps/web/src/app/[locale]/error.tsx");
